import { getItemsParamArray } from '../../../utils/apiRequests/getItemsParamArray';
import { getItemsQueryString } from '../../../utils/apiRequests/getItemsQueryString';
import { getLimitQueryString } from '../../../utils/apiRequests/getLimitQueryString';
import { getOffsetQueryString } from '../../../utils/apiRequests/getOffsetQueryString';
import { getSortParamArray } from '../../../utils/apiRequests/getSortParamArray';
import { getSortQueryString } from '../../../utils/apiRequests/getSortQueryString';
import { getUrlParamsStringFromArray } from '../../../utils/apiRequests/getUrlParamsStringFromArray';
import { stringifyBracketParameter } from '../../../utils/apiRequests/stringifyBracketParameter';
import { getReferenceFilterParamObject } from './getReferenceFilterParamObject';

// Mirrors getDataParamsString, but builds filters via getReferenceFilterParamObject so
// `or`/`and` reference filter groups serialize correctly — see that file for why the
// shared getFilterParamObject (used by DatasetList/slave-filter fetching) isn't reused here.
export const getReferenceDataParamsString = (
  activeFilters: Record<string, any> | null,
  activeSorting: { field: string; order: number }[],
  dataset: any,
  limit?: number,
  offset?: number,
  itemsOverride?: string[],
  // Already request-shaped filter merged on top of the converted activeFilters,
  // taking precedence. Used for the reference's locked default filter
  // (control.filter), which is kept out of activeFilters/lazyState entirely.
  additionalFilterObject?: Record<string, any>
) => {
  const urlParams: string[] = [];
  const items = itemsOverride ?? getItemsParamArray(dataset);
  const itemsQuery = getItemsQueryString(items);
  if (itemsQuery) {
    urlParams.push(itemsQuery);
  }

  const sortParamArray = getSortParamArray(activeSorting);
  const sortQuery = getSortQueryString(sortParamArray);
  if (sortQuery) {
    urlParams.push(sortQuery);
  }

  const filtersObject = {
    ...getReferenceFilterParamObject(activeFilters),
    ...(additionalFilterObject ?? {}),
  };
  const filterString = stringifyBracketParameter({ filter: filtersObject });
  if (filterString) {
    urlParams.push(filterString);
  }

  if (limit) {
    urlParams.push(getLimitQueryString(limit));
  }

  if (offset) {
    urlParams.push(getOffsetQueryString(offset));
  }

  return getUrlParamsStringFromArray(urlParams);
};
